// Vendor
import { defineStore } from 'pinia';
export const useContextStore = defineStore('context', {});
//# sourceMappingURL=context.js.map